import React from 'react';
import { Link } from 'react-router-dom';
import { ROUTES } from '../../config/routes';
import useEquipment, { useEquipmentLabels } from './hooks/useEquipment';
import EquipmentHero from './components/EquipmentHero';
import EquipmentMetrics from './components/EquipmentMetrics';
import EquipmentFeatures from './components/EquipmentFeatures';
import EquipmentVideo from './components/EquipmentVideo';
import EquipmentSpecifications from './components/EquipmentSpecifications';
import EquipmentOptions from './components/EquipmentOptions';
import './EquipmentIntroPage.css';

export default function EquipmentDetailPage({ equipment }) {
  const product = useEquipment(equipment);
  const label = useEquipmentLabels();
  const specsId = product.specificationsAnchor;
  return <main className="equipment-page">
    <div className="equipment-container equipment-back">
      <Link to={{ pathname: ROUTES.root, hash: '#equipment' }}>← {label('title')}</Link>
    </div>
    <EquipmentHero product={product} specsId={specsId} />
    <EquipmentMetrics metrics={product.metrics} />
    <EquipmentFeatures features={product.features} />
    <EquipmentVideo video={product.video} />
    <EquipmentSpecifications id={specsId} name={product.name} specifications={product.specifications} note={product.specificationNote} />
    <EquipmentOptions options={product.options} catalog={product.catalog} />
    <div className="equipment-container equipment-bottom">
      <Link to={{ pathname: ROUTES.root, hash: '#equipment' }}>← {label('back')}</Link>
    </div>
  </main>;
}
